export default __webpack_public_path__ + "static/image-48-e60cd5df5e0adde7fcff772807650c97.jpg";